import React from "react";
import TriangleRightIcon from "./icons/TriangleRightIcon.jsx";

export default function RequestField({
  icon,
  title,
  value,
  type = "default",
}: {
  icon: () => React.JSX.Element;
  title: string;
  value: string;
  type?: "default" | "textarea" | "subform";
}) {
  return (
    <div className='tw-flex tw-items-center tw-gap-8 tw-pb-3 tw-pt-3'>
      <span>{icon()}</span>
      <div>
        <div>{title}</div>
        <div
          className={`
          tw-text-[#707070]
          ${
            type === "textarea"
              ? "tw-mt-2 tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-[#9B9B9B] tw-pb-3 tw-text-[inherit]"
              : "tw-mt-1 tw-text-sm"
          }
        `}
        >
          {value}
        </div>
      </div>

      {type === "subform" && (
        <div className='tw-ml-auto'>
          <TriangleRightIcon className='tw-fill-[#767676]' />
        </div>
      )}
    </div>
  );
}
